<template>
  <div>
    <vx-card class="mb-5 mt-base" title="Work Experience Certificate">
      <template v-if="!postwork.certificate_status || postwork.certificate_status == 0">
        <p class="mb-5">
          This student hasn't requested that you approve their Work Experience Certificate yet.
        </p>
      </template>
      <template v-else-if="postwork.certificate_status == 1">
        <p class="mb-5">
          This student has requested that you approve their Work Experience Certificate on
          {{ postwork.certificate_date_requested }}.
        </p>
        <button
          class="btn btn-secondary btn-size-medium includedIcon"
          @click="approveCertificate()"
          :class="{ 'float-left mr-5': experience.type == 1 }"
        >
          <file-plus-icon />Approve Certificate
        </button>
        <template v-if="experience.type == 1">
          <h5 class="float-left pt-3 pr-4">OR</h5>
          <button
            class="btn btn-secondary btn-size-medium danger includedIcon"
            @click="confirmDeclineCertificate()"
          >
            <file-minus-icon />Decline Certificate
          </button>
        </template>
        <vs-progress indeterminate color="primary" v-if="approvingCertificate"></vs-progress>
      </template>
      <template v-else-if="postwork.certificate_status == 2">
        <p class="mb-5">
          You have approved this student's Work Experience Certificate on
          {{ postwork.certificate_date_approved }}.
        </p>
        <button class="btn btn-secondary btn-size-medium includedIcon" @click="viewCertificate()">
          <download-icon />View Certificate
        </button>
      </template>
      <template v-else-if="postwork.certificate_status == 3">
        <p class="mb-5">
          You have declined this student's Work Experience Certificate on
          {{ postwork.certificate_date_declined }}.
        </p>
        <heading size="h3" style-size="h5" class="mb-5 font-normal"
          ><u>Reason for declining:</u></heading
        >
        <p>{{ postwork.reason_for_declining }}</p>
      </template>
    </vx-card>

    <vs-prompt
      @cancel="clearDeclineVals"
      @accept="declineCertificate"
      accept-text="Decline"
      color="danger"
      title="Decline Certificate"
      :active.sync="showDeclineDialog"
    >
      <div class="con-exemple-prompt">
        Please enter a reason for declining the certificate request.
        <vs-textarea
          placeholder="Reason"
          v-model="reason_for_declining"
          class="w-full mt-4 mb-2"
          height="200px"
        ></vs-textarea>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import store from '@/store/store';
import theApi from '@/mixins/theApi';
import state from '@/store/store';
import { FilePlusIcon, FileMinusIcon, DownloadIcon } from 'vue-feather-icons';

export default {
  components: {
    FilePlusIcon,
    FileMinusIcon,
    DownloadIcon,
  },
  computed: {
    experience() {
      return state.getters['authTeacher/experience'];
    },
    postwork() {
      if (typeof this.experience.postwork !== 'undefined' && this.experience.postwork != null)
        return this.experience.postwork;
      else return {};
    },
  },
  data() {
    return {
      approvingCertificate: false,
      showDeclineDialog: false,
      reason_for_declining: '',
    };
  },
  methods: {
    async approveCertificate() {
      this.approvingCertificate = true;
      const formData = new FormData();
      formData.append('student_vje_id', this.$route.params.id);

      theApi.methods.makeCall(false, 'vje_students/approve_certificate', 'post', formData).then(
        (data) => {
          if (data.status == 'OK') {
            store.commit('authTeacher/setExperiencePostwork', data.data.postwork);
            this.approvingCertificate = false;
          }
        },
        () => {},
      );

      //store.dispatch('authTeacher/approveCertificate', this.$route.params.id);
    },
    clearDeclineVals() {
      this.reason_for_declining = '';
    },
    confirmDeclineCertificate() {
      this.showDeclineDialog = true;
    },
    async declineCertificate() {
      this.approvingCertificate = true;
      const formData = new FormData();
      formData.append('student_vje_id', this.$route.params.id);
      formData.append('reason_for_declining', this.reason_for_declining);

      theApi.methods.makeCall(false, 'vje_students/decline_certificate', 'post', formData).then(
        (data) => {
          if (data.status == 'OK') {
            store.commit('authTeacher/setExperiencePostwork', data.data.postwork);
            this.approvingCertificate = false;
          }
        },
        () => {},
      );

      //store.dispatch('authTeacher/approveCertificate', this.$route.params.id);
    },
    viewCertificate() {
      store.dispatch('popup/showIframePopup', this.postwork.certificate_url);
    },
  },
};
</script>
